import React from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { get } from 'lodash';

const generalStyle = css`
  border-radius: 0.5rem;
  width: 100%;
  background: #faf9f8;
  display: flex;
  padding: 1rem;
  align-items: center;
  box-sizing: border-box;
`;

const warningMessageStyle = css`
  border: 0.0625rem solid #f7d171;
`;

const infoMessageStyle = css`
  border: 0.0625rem solid #b3d3eb;
`;

const iconStyle = css`
  margin-right: 0.625rem;
`;

const textStyle = css`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
`;

const UserMessage = (props) => {
  const className = get(props, 'className');
  const messageText = get(props, 'messageText');
  const messageType = get(props, 'messageType');

  const warningIcon = (
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="warning">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.40238 1.5C9.55708 -0.500002 12.4438 -0.499998 13.5985 1.5L20.9598 14.25C22.1145 16.25 20.6711 18.75 18.3617 18.75H3.63924C1.32984 18.75 -0.113535 16.25 1.04117 14.25L8.40238 1.5ZM12.7325 2C11.9627 0.666667 10.0382 0.666666 9.26841 2L1.90719 14.75C1.13739 16.0833 2.09964 17.75 3.63924 17.75H18.3617C19.9013 17.75 20.8635 16.0833 20.0937 14.75L12.7325 2Z"
        fill="#9C6E19"
      />
      <path
        d="M10.4755 5.7304C10.613 5.5768 10.788 5.5 11.0005 5.5C11.213 5.5 11.3942 5.5768 11.5442 5.7304C11.6817 5.884 11.7505 6.0632 11.7505 6.268V11.516C11.7505 11.7208 11.6817 11.9 11.5442 12.0536C11.3942 12.2072 11.213 12.284 11.0005 12.284C10.788 12.284 10.613 12.2072 10.4755 12.0536C10.3255 11.9 10.2505 11.7208 10.2505 11.516V6.268C10.2505 6.0632 10.3255 5.884 10.4755 5.7304ZM10.4755 13.6568C10.613 13.516 10.788 13.4456 11.0005 13.4456C11.213 13.4456 11.3942 13.516 11.5442 13.6568C11.6817 13.8104 11.7505 13.996 11.7505 14.2136V14.732C11.7505 14.9368 11.6817 15.116 11.5442 15.2696C11.3942 15.4232 11.213 15.5 11.0005 15.5C10.788 15.5 10.613 15.4232 10.4755 15.2696C10.3255 15.116 10.2505 14.9368 10.2505 14.732V14.2136C10.2505 13.996 10.3255 13.8104 10.4755 13.6568Z"
        fill="#9C6E19"
      />
    </svg>
  );

  const infoIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="info">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0004 1.5394C5.77551 1.5394 1.53988 5.77502 1.53988 10.9999C1.53988 16.2248 5.77551 20.4605 11.0004 20.4605C16.2253 20.4605 20.4609 16.2248 20.4609 10.9999C20.4609 5.77502 16.2253 1.5394 11.0004 1.5394ZM0.460938 10.9999C0.460938 5.17913 5.17962 0.460449 11.0004 0.460449C16.8212 0.460449 21.5399 5.17913 21.5399 10.9999C21.5399 16.8207 16.8212 21.5394 11.0004 21.5394C5.17962 21.5394 0.460938 16.8207 0.460938 10.9999Z"
        fill="#3E7CA8"
      />
      <path
        d="M11.5879 16.235C11.4275 16.4116 11.2233 16.4999 10.9754 16.4999C10.7275 16.4999 10.516 16.4116 10.341 16.235C10.1806 16.0583 10.1004 15.8522 10.1004 15.6167V9.58152C10.1004 9.346 10.1806 9.13992 10.341 8.96328C10.516 8.78664 10.7275 8.69832 10.9754 8.69832C11.2233 8.69832 11.4275 8.78664 11.5879 8.96328C11.7629 9.13992 11.8504 9.346 11.8504 9.58152V15.6167C11.8504 15.8522 11.7629 16.0583 11.5879 16.235ZM11.5879 7.1196C11.4275 7.28152 11.2233 7.36248 10.9754 7.36248C10.7275 7.36248 10.516 7.28152 10.341 7.1196C10.1806 6.94296 10.1004 6.72952 10.1004 6.47928V5.88312C10.1004 5.6476 10.1806 5.44152 10.341 5.26488C10.516 5.08824 10.7275 4.99992 10.9754 4.99992C11.2233 4.99992 11.4275 5.08824 11.5879 5.26488C11.7629 5.44152 11.8504 5.6476 11.8504 5.88312V6.47928C11.8504 6.72952 11.7629 6.94296 11.5879 7.1196Z"
        fill="#3E7CA8"
      />
    </svg>
  );

  const isWarningMessage = messageType === 'warning';
  const styleByType = isWarningMessage
    ? `${generalStyle} ${warningMessageStyle}`
    : `${generalStyle} ${infoMessageStyle}`;

  return (
    <div
      className={`${styleByType}${className ? ` ${className}` : ''}`}
      aria-label={`${isWarningMessage ? 'warning' : 'info'}, ${messageText}`}
      data-testid="user-message"
    >
      <div className={iconStyle} aria-hidden={true}>
        {isWarningMessage ? warningIcon : infoIcon}
      </div>
      <div className={textStyle} aria-hidden={true}>
        {messageText}
      </div>
    </div>
  );
};

UserMessage.propTypes = {
  className: PropTypes.string,
  messageText: PropTypes.string.isRequired,
  messageType: PropTypes.oneOf(['info', 'warning']),
};

export default UserMessage;
